import { Button, type ButtonProps } from "@design-system/shadcn";
import React from "react";

import { useFormContext } from "../core/form-contexts";

type SubmitButtonProps = ButtonProps & {
  loadingLabel?: string;
};

function SubmitButton({
  children,
  disabled,
  loadingLabel,
  ...buttonProps
}: SubmitButtonProps) {
  const form = useFormContext();

  if (!form) {
    throw new Error("SubmitButton must be used within form.AppForm");
  }

  return (
    <form.Subscribe selector={(state) => [state.canSubmit, state.isSubmitting]}>
      {([canSubmit, isSubmitting]) => {
        const isDisabled = disabled || !canSubmit;
        return (
          <Button
            {...buttonProps}
            type="submit"
            disabled={isDisabled}
            isLoading={isSubmitting}
            loadingLabel={loadingLabel}
          >
            {children}
          </Button>
        );
      }}
    </form.Subscribe>
  );
}

export { SubmitButton };
export type { SubmitButtonProps };
